export default __webpack_public_path__ + "static/media/simulation-computer.d809fe8c.svg";